import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);
  const [items, setItems] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); setItems([]); return; }
    try {
      const { data } = await api.get("/wishlist");
      setIds(data.product_ids || []);
      setItems(data.items || []);
    } catch { setIds([]); setItems([]); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isIn = (product_id) => ids.includes(product_id);

  const toggle = async (product_id) => {
    if (!user) return { ok: false, needAuth: true };
    try {
      if (isIn(product_id)) {
        await api.delete(`/wishlist/${product_id}`);
        setIds(ids.filter((x) => x !== product_id));
        setItems(items.filter((x) => x.product_id !== product_id));
      } else {
        await api.post("/wishlist", { product_id });
        setIds([...ids, product_id]);
        // Refresh items list to get full product
        refresh();
      }
      return { ok: true };
    } catch { return { ok: false }; }
  };

  return (
    <WishlistContext.Provider value={{ ids, items, isIn, toggle, refresh, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
